<template>
  <div class="row-container">
    <div class="toolbar">
      <div class="actions">
        <b-button size="sm" @click="toggleEdit"><fa icon="bars"></fa></b-button>
        <b-button size="sm" @click="$emit('move-up', index)" :disabled="index === 0" v-if="siblingCount > 1"><fa icon="arrow-up"></fa></b-button>
        <b-button size="sm" @click="$emit('move-down', index)" :disabled="index >= siblingCount - 1" v-if="siblingCount > 1"><fa icon="arrow-down"></fa></b-button>
        <b-button size="sm" variant="danger" @click="$emit('remove-row', index)" class="actions--right" :disabled="siblingCount <= 1" v-if="siblingCount > 1"><fa icon="times"></fa></b-button>
      </div>

      <div class="properties" v-if="isEditing">
        <attribute-editor
          :attributes="obj.attributes"
          @changed="attributesChanged"
        ></attribute-editor>
      </div>
    </div>

    <div class="body">
      <template
        v-for="(child, i) in obj.children"
        class="column"
      >
        <b-button
          size="sm"
          class="add-button"
          @click="addColumn(i)"
          v-if="obj.children.length < 3"
          :key="i"
        ><fa icon="plus"></fa></b-button>

        <column-container
          :key="child.id"
          :id="child.id"
          :obj="child"
          :sibling-count="obj.children.length"
          :index="i"
          :substitution-tags="substitutionTags"
          @width-changed="columnWidthChanged"
          @move-left="moveLeft"
          @move-right="moveRight"
          @remove-column="removeColumn"
        ></column-container>
      </template>

      <b-button
        size="sm"
        class="add-button"
        @click="addColumn()"
        v-if="obj.children.length < 3"
      ><fa icon="plus"></fa></b-button>
    </div>
  </div>
</template>

<script>
import * as elements from './elements'
import ColumnContainer from './ColumnContainer'
import AttributeEditor from './AttributeEditor'

const arrayMove = (arr, from, to) => arr.splice(to, 0, arr.splice(from, 1)[0])

export default {
  name: 'RowContainer',

  components: {
    ColumnContainer,
    AttributeEditor
  },

  props: [
    'obj',
    'siblingCount',
    'index',
    'substitutionTags'
  ],

  data() {
    return {
      isEditing: false
    }
  },

  computed: {
    style() {
      return this.obj.style()
    }
  },

  mounted() {
    this.distributeColumnWidths()
  },

  methods: {
    toggleEdit() {
      this.isEditing = !this.isEditing
    },

    addColumn(i) {
      let col = new elements.ColumnContainer()

      if (typeof i === 'number') {
        this.obj.children.splice(i, 0, col)
      } else {
        this.obj.children.push(col)
      }

      this.distributeColumnWidths()
    },

    removeColumn(i) {
      if (confirm('Are you sure you want to remove this column?')) {
        this.obj.children.splice(i, 1)
        this.distributeColumnWidths()
      }
    },

    distributeColumnWidths() {
      let width = 1 / this.obj.children.length
      this.obj.children.forEach(c => { c.attributes.width.value = `${Math.floor(width * 100)}%` })
    },

    columnWidthChanged(id, width) {
      let col = this.obj.children.find(c => c.id === id)

      let twoColumnMapping = {
        '33%': '66%',
        '66%': '33%',
        '50%': '50%'
      }

      col.attributes.width = width
      this.obj.children.filter(c => c.id !== id).forEach(c => { c.attributes.width = twoColumnMapping[width] })
    },

    moveLeft(i) {
      if (i > 0) {
        arrayMove(this.obj.children, i, i - 1)
      }
    },

    moveRight(i) {
      if (i < this.obj.children.length - 1) {
        arrayMove(this.obj.children, i, i + 1)
      }
    },

    attributesChanged(val) {
      this.obj.attributes = val
    }
  }
}
</script>

<style scoped>
  .row-container {
    position: relative;

    /*border: solid 1px #CCC;*/
    border-radius: 5px;
    /*box-shadow: 0 0 10px rgba(0,0,0,0.5);*/
  }

  .row-container + .row-container {
    margin-top: 5px;
  }

  .toolbar {
    padding: 5px;

    border-bottom: solid 1px #CCC;
    background: #EEE;
  }

  .actions {
    display: flex;
  }

  .actions > * + * {
    margin-left: 5px;
  }

  .actions--right {
    margin-left: auto;
  }

  .column {
    display: flex;
    flex-grow: 1;
  }

  .column + .column {
    margin-left: 5px;
  }

  .body {
    display: flex;
    padding: 10px;
  }

  .add-button {
    height: 30px;
    width: 30px;
    margin: auto -10px;
    z-index: 100;
  }
</style>
